import React from "react";
import { NavLink } from "react-router-dom";
import "./NavLink.css";

const NavLinks = () => {
  return (
    <ul className="nav-links">
      <li>
        <NavLink to="/">Home</NavLink>
      </li>
      <li>
        <NavLink to="/Projects">Projects</NavLink>
      </li>
      <li>
        <NavLink to="/Blogs">Blogs</NavLink>
      </li>
      <li>
        <a href="https://drive.google.com/file/d/1fo0fX2_MFeFbkxdpHTKWOVgx7qHziPGF/view?usp=sharing" target="_blank">Resume</a>
      </li>
    </ul>
  );
};

export default NavLinks;
